/* VIP Sale 2026 – verstecktes Warenkorb-Attribut  vip_sale = "2026-10"  (Organisator, 20.10.2026).
   Vorgabe IT (Peter): Name exakt klein „vip_sale“, Wert fix „2026-10“, als Cart-Attribut (landet beim Anlegen der Bestellung in
   note_attributes / „Zusätzliche Details“), Kunde sieht es nicht. Keine Tags/Metafelder/Notiz.
   Gesetzt, solange VIP.phase().active === true (25.10. 08:00 – 27.10. 23:59:59 Wien) und der Warenkorb nicht leer ist;
   außerhalb des Sales wird ein übrig gebliebenes „2026-10“ entfernt. Die Checkout-Extension vip-usp setzt denselben Wert
   zusätzlich im Checkout (doppelt hält besser, auch bei Express-Checkout aus dem Warenkorb ist es so schon dabei). */
(function () {
  'use strict';
  var KEY = 'vip_sale', VALUE = '2026-10', busy = false;
  function sync() {
    var V = window.VIP; if (!V || busy) return;
    var cart = V.cart; if (!cart || !cart.item_count) return;
    var cur = (cart.attributes || {})[KEY] || null;
    var want = V.phase().active ? VALUE : null;
    if (want === cur || (want === null && cur !== VALUE)) return;
    var attrs = {}; attrs[KEY] = want === null ? '' : want;
    busy = true;
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.items) V.cart = c; })
      .catch(function (e) { console.warn('[VIP] vip_sale-Attribut', e); })
      .then(function () { busy = false; });
  }
  function boot() {
    if (!window.VIP) { setTimeout(boot, 300); return; }
    window.VIP.onPhase(function () { sync(); });
    window.VIP.onCart(function () { sync(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Gespeicherter Warenkorb-Link (Organisator, 20.10.2026): Shopify-Permalinks /cart/VAR:MENGE?storefront=true enden auf der
   Warenkorbseite /cart?cart_link_id=… – gewünscht ist der gewohnte Warenkorb-Drawer. Darum: /cart mit cart_link_id -> Startseite
   mit ?vip_cart=1 -> Drawer öffnet sich (cart:refresh {open:true} aus assets/cart.js). Bereits verschickte Links bleiben gültig.
   Demo (nur Vorschau, nie im Live-Theme): ?vip_demo_cart=VAR:MENGE,VAR:MENGE ersetzt den Warenkorb und öffnet den Drawer –
   zusammen mit ?vip_phase=… in EINEM Link, weil die Phasen-Simulation pro Tab gespeichert wird. */
(function () {
  'use strict';
  try {
    var u = new URL(window.location.href);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (/\/cart\/?$/.test(u.pathname) && u.searchParams.has('cart_link_id')) {
      window.location.replace(root + '?vip_cart=1');
      return;
    }
    var demo = u.searchParams.get('vip_demo_cart');
    var isMain = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
    if (demo && isMain) demo = null;
    if (u.searchParams.get('vip_cart') !== '1' && !demo) return;
    u.searchParams.delete('vip_cart');
    u.searchParams.delete('vip_demo_cart');
    try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    var openDrawer = function () {
      if (!document.querySelector('cart-drawer')) return;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    };
    var fill = function () {
      if (!demo) return Promise.resolve();
      var items = demo.split(',').map(function (p) { var a = p.split(':'); return { id: Number(a[0]), quantity: Number(a[1] || 1) }; })
        .filter(function (i) { return i.id > 0 && i.quantity > 0; });
      var opt = function (body) { return { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }; };
      return fetch(root + 'cart/clear.js', opt({})).then(function () { return fetch(root + 'cart/add.js', opt({ items: items })); })
        .then(function () { try { if (window.VIP && VIP.refreshCart) return VIP.refreshCart(); } catch (e) {} });
    };
    var go = function () {
      var ready = (window.customElements && customElements.whenDefined) ? customElements.whenDefined('cart-drawer') : Promise.resolve();
      Promise.all([ready, fill()]).then(function () { setTimeout(openDrawer, 150); })
        .catch(function (e) { console.warn('[VIP] Demo-Warenkorb', e); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  } catch (e) { console.warn('[VIP] Warenkorb-Link', e); }
})();
